import React, { Fragment } from "react";
import Iran from "Assets/svg/flag-icons/iran.svg";
import German from "Assets/svg/flag-icons/germany.svg";
import Turkey from "Assets/svg/flag-icons/turkey.svg";
function CountryFormatter(cell) {
  return (
    <Fragment>
      {cell === 1 ? <img src={Iran} height={19} width="auto" alt=" " /> : null}
      {cell === 2 ? (
        <img src={German} height={19} width="auto" alt=" " />
      ) : null}
      {cell === 3 ? (
        <img src={Turkey} height={19} width="auto" alt=" " />
      ) : null}
    </Fragment>
  );
}

export default CountryFormatter;
